import React, { Component } from 'react';
import { ScheduleSettings } from '../ScheduleSettings';

export class PageSchedule extends Component {
  render(){
    return (
      <ScheduleSettings/>
    );
  }
}
